import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";

const THRESHOLD = 70;

export default function PullToRefresh({ onRefresh, children }) {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(null);

  const onTouchStart = (e) => {
    startY.current = window.scrollY <= 0 && !refreshing ? e.touches[0].clientY : null;
  };
  const onTouchMove = (e) => {
    if (startY.current == null) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0) setPull(Math.min(dy * 0.5, 90));
  };
  const onTouchEnd = async () => {
    if (startY.current != null && pull >= THRESHOLD) {
      setRefreshing(true);
      if (navigator.vibrate) navigator.vibrate(8);
      try { await onRefresh?.(); } finally { setRefreshing(false); }
    }
    setPull(0);
    startY.current = null;
  };

  const armed = pull >= THRESHOLD;
  return (
    <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} data-testid="pull-to-refresh">
      <div className="flex items-center justify-center overflow-hidden transition-[height] duration-150" style={{ height: refreshing ? 40 : pull }}>
        {(refreshing || pull > 4) && (
          <Loader2 className={`w-5 h-5 text-primary ${refreshing || armed ? "animate-spin" : ""}`} style={{ opacity: Math.min(pull / THRESHOLD, 1) || 1 }} />
        )}
      </div>
      {children}
    </div>
  );
}
